import React, { createContext } from 'react';

type SetLogoFunction = (url: string) => void;

export interface AppState {
  logo: string;
  setLogo: SetLogoFunction;
}

const AppContext = React.createContext<Partial<AppState>>({});
// export const UserContext = React.createContext<partial<user>>({});

export default AppContext;
